import { useIntl } from 'react-intl';
import { Button } from 'components/ui/atoms/button';
import { getEnvOrFail } from 'env/env';
import { formatProgramType } from '../utils';
import { StartButtonProps } from './types';

export const StartButton = ({
  program,
  courseURL,
  size,
  block = false,
  className,
}: StartButtonProps) => {
  const { formatMessage } = useIntl();

  const renderCourseStartButton = () => (
    <Button
      variant="brand"
      asChild
      radius="none"
      size={size}
      block={block}
      className={className}
    >
      <a href={courseURL}>
        {formatMessage({
          id: 'payment.thankyou.product.start.course',
          defaultMessage: 'Start course',
          description: 'CTA to start the course after successful payment',
        })}
      </a>
    </Button>
  );

  const renderProgramStartButton = () => {
    const lmsBaseUrl = getEnvOrFail('NEXT_PUBLIC_EDX_LMS_BASE_URL');
    const programDashboardPath = getEnvOrFail(
      'NEXT_PUBLIC_EDX_LMS_PROGRAM_DASHBOARD_PATH',
    );
    const programUrl = `${lmsBaseUrl + programDashboardPath + program!.productKey!}/`;

    return (
      <Button
        variant="brand"
        asChild
        radius="none"
        size={size}
        block={block}
        className={className}
      >
        <a href={programUrl}>
          {formatMessage(
            {
              id: 'payment.thankyou.product.start.program',
              defaultMessage: 'Start the {programType}',
              description: 'CTA to start the program after successful payment',
            },
            // @ts-expect-error programType is valid
            { programType: formatProgramType(program.attributes?.type) },
          )}
        </a>
      </Button>
    );
  };

  return program ? renderProgramStartButton() : renderCourseStartButton();
};
